<template lang="pug">
  .notice.pos-r(
    v-if="getRollFont",
    @touchstart='togglePlay',
    @mouseover="stop",
    @mouseout="replay")
    .icon(:style="imgStyle")
    .notice-wrap.tac.pos-a
      .notice-bar-content(ref="noticeConten")
        .notice-text {{getRollFont}}
        .notice-text {{getRollFont}}
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      raf: null,
      running: true,
      offsetWidth: 0,
    }
  },
  created() {
    this.imgStyle = {
      backgroundImage: `url(${window.$globalconfig.URLS.API}krpano/images/notice.png)`,
    }
  },
  computed: {
    ...mapGetters(['getRollFont']),
  },
  methods: {
    initWidth() {
      setTimeout(() => {
        const { noticeConten } = this.$refs
        if (!noticeConten) {
          return
        }
        let noticeText = noticeConten.children
        let offsetWidth = noticeText[0].getBoundingClientRect().width

        if (offsetWidth < document.documentElement.clientWidth) {
          noticeText[0].style.width = noticeText[1].style.width =
            document.documentElement.clientWidth + 'px'
          offsetWidth = document.documentElement.clientWidth
        }

        noticeConten.style.width = offsetWidth * 2 + 'px'

        this.offsetWidth = offsetWidth
        this.move()
      }, 100)
    },
    move() {
      const { noticeConten } = this.$refs
      let speed = 0
      clearInterval(this.raf)
      this.raf = setInterval(() => {
        if (!this.running) return
        if (speed < this.offsetWidth) {
          speed += 4
        } else {
          noticeConten.style.left = 0
          speed = 0
        }
        noticeConten.style.transform = `translateX(${-speed}px)`
      }, 100)
    },
    togglePlay() {
      this.running = !this.running
    },
    replay() {
      this.running = true
    },
    stop() {
      this.running = false
      cancelAnimationFrame(this.raf)
    },
    beforeDestroy() {
      this.stop()
    },
  },
  watch: {
    getRollFont: {
      handler() {
        this.$nextTick(() => {
          setTimeout(() => {
            this.initWidth()
          }, 500)
        })
      },
      immediate: true,
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '~assets/styles/variables.styl'
$width = 100%

.theme-b
  .notice
    position: absolute
    top: 0
    left: 0
    right: 0
    background: rgba(0, 0, 0, .5)
    z-index: $--zindex-mid

.notice
  width: $width
  height: 30px

  .icon
    position: absolute
    left: 2px
    top: 7px
    width: 16px
    height: 16px
    background-size: 100% 100%

  .notice-wrap
    width: calc(100% - 20px)
    top: 0
    left: 20px
    height: 100%
    overflow: hidden

  .notice-bar-content
    min-width: 10000px
    height: 100%
    line-height: 100%
    overflow: hidden

    .notice-text
      float: left
      height: 100%
      line-height: 30px
      font-size: 13px
      box-sizing: border-box
      color: yellow
</style>
